import {Navigate, useLocation} from "react-router-dom";

const PublicRoute = ({children}) => {
    const location = useLocation();
    let  token = localStorage.getItem("token");
    if ((location.pathname === '/' || location.pathname === '/otp') && token) {
        return <Navigate to="/admin/home" />;
    }



    return children;

}
export default PublicRoute;